import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import ProveedorNotasAvisos from './ProveedorNotasAvisos';
import proveedorService from '../services/proveedorService';
import { normalizarNotasProveedor } from '../utils/proveedorNotas';

interface Props {
  nroProveedor?: number | null;
  /** Campo Observaciones (TextField u otro control fullWidth). */
  children: React.ReactNode;
}

/**
 * Observaciones a la izquierda y Nota 1 del proveedor a la derecha (Alert).
 * Si hay Nota 1, Observaciones pasa a mitad de ancho para dejarle lugar.
 */
const ObservacionesConNotaProveedor: React.FC<Props> = ({ nroProveedor, children }) => {
  const [notas, setNotas] = useState<string | null>(null);

  useEffect(() => {
    const nro = Number(nroProveedor);
    if (!Number.isFinite(nro) || nro <= 0) {
      setNotas(null);
      return;
    }

    let cancelled = false;
    setNotas(null);
    (async () => {
      try {
        const proveedor = await proveedorService.getProveedor(nro);
        if (!cancelled) {
          setNotas(normalizarNotasProveedor(proveedor.notas));
        }
      } catch {
        if (!cancelled) setNotas('');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [nroProveedor]);

  const mostrarNota = Boolean(normalizarNotasProveedor(notas));

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12} md={mostrarNota ? 6 : 12}>
        {children}
      </Grid>
      {mostrarNota ? (
        <Grid item xs={12} md={6}>
          <ProveedorNotasAvisos nroProveedor={nroProveedor} notas={notas} />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default ObservacionesConNotaProveedor;
